import { useEffect, useState } from "react";
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";
import useAppStore from "../store/AppStore";
import { loadMenuForUser } from "../common/services/menu_request";
import { Spin } from "antd";

const AuthController = () => {
  const {
    isConnected,
    setIsConnected,
    setAuthorizationData,
    appLoading,
    setAppLoading,
    setMenus,
    authorizationData,
    resetAuthorizationData,
  } = useAppStore();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const loadMenus = async () => {
    try {
      setIsLoading(true);

      const menus = await loadMenuForUser();
      if (menus && menus?.member) {
        setMenus(menus);
        setIsConnected(true);
      } else if (!menus) {
        resetAuthorizationData();
        setIsConnected(false);
        setAuthorizationData(null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const loadData = async () => {
    if (!isConnected && authorizationData) {
      loadMenus();
    }
    setAppLoading(false);
  };

  useEffect(() => {
    loadData();
  }, [authorizationData]);

  if (appLoading || isLoading)
    return (
      <div className="loader-container">
        <Spin size="large" />
      </div>
    );

  return (
    <div className="h-100">
      {authorizationData && <PrivateRoutes />}
      {!authorizationData && <PublicRoutes />}
    </div>
  );
};

export default AuthController;
